/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TrainingOption } from '../../models/training-option';

export interface ApiMasterTrainingGetActiveOptionsGet$Params {
}

export function apiMasterTrainingGetActiveOptionsGet(http: HttpClient, rootUrl: string, params?: ApiMasterTrainingGetActiveOptionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrainingOption>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrainingGetActiveOptionsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TrainingOption>>;
    })
  );
}

apiMasterTrainingGetActiveOptionsGet.PATH = '/api/Master/Training/GetActiveOptions';
